export interface ICarrierOrganizationOutputDto {
    name: string;
    vatNumber: string;
    email?: string;
    country: string;
}
